import { ContainerModule } from 'inversify';
import { configModule } from '@dataroom/config/DI/configModule';
import { domainModule } from '@dataroom/domain/DI/domainModule';

export const rootModules: ContainerModule[] = [
  domainModule,
  configModule,
];
